import "./src/styles/global.css";
import "./src/styles/howto-motion.css";

// Important SEO change:
// Remove all client-side language redirects to prevent soft redirects
// that cause "Page with redirect" in Google Search Console.
// URL language is now chosen explicitly by users and links/hreflang.

export const onClientEntry = () => {
  // no-op: avoid JS-based redirects or URL rewrites
};

export const onRouteUpdate = () => {
  // no-op: avoid JS-based redirects or URL rewrites
};
